import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.veranstaltung-logo-scaled';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungLogoScaledEffects {

    VeranstaltungLogoScaled$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNG_LOGO_SCALED),
        mergeMap((x: ac.GetVeranstaltungLogoScaledAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungLogoScaled(x.veranstaltung_id, x.width, x.height).pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungLogoScaledErfolgreichAction(result, x.veranstaltung_id, x.width, x.height, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungLogoScaledFehlerAction(error, x.veranstaltung_id, x.width, x.height, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VeranstaltungenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VeranstaltungenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.VeranstaltungenQueryService);
        }
        return this.service;
    }
}
